import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'drawingName'
})
export class DrawingNamePipe implements PipeTransform {

    transform(name: string): string {
        return `${name}`.replaceAll('Verkeersmaatregelen', '').trim();
    }

}
